import { buildOriginalFilterPath } from "PFCore/helpers/filters/filter_path";
import { AnyFilterV2, FilterTypeV2, FilterV2 } from "PFTypes/filters_v2";

export type MinimalFilterDefinition = Partial<
  Omit<AnyFilterV2, "name" | "group" | "collection" | "originalPath">
> &
  Pick<AnyFilterV2, "name" | "group" | "collection">;

export const buildFilterV2 = ({ name, group, ...filterData }: MinimalFilterDefinition): FilterV2 => ({
  name,
  group,
  originalPath: buildOriginalFilterPath(group, name),
  type: FilterTypeV2.SelectOne,
  title: "",
  value: null,
  ...filterData
});
